var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.$route.path === '/plan/delicious')?_c('page',[_c('ZuiHeader'),_vm._v(" "),_c('SubPageTemplate',{attrs:{"page-title":"吃得巴适","dynamically-tab":"","pid":_vm.pid,"default-tab-id":_vm.tabId,"isShowTab":false,"page-size":6,"type":"article","video-mask":false},on:{"article-click":_vm.articleClick}}),_vm._v(" "),_c('ZuiFooter')],1):_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9903774","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/plan/delicious.vue
// module id = 1459
// module chunks = 0